import { render } from "./PatientPortal.vue?vue&type=template&id=46cf0678&scoped=true"
import script from "./PatientPortal.vue?vue&type=script&lang=js"
export * from "./PatientPortal.vue?vue&type=script&lang=js"

import "./PatientPortal.vue?vue&type=style&index=0&id=46cf0678&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cf0678"]])

export default __exports__